// Spain
export const locale = {
  lang: 'es',
  data: {
    TRANSLATOR: {
      SELECT: 'Selecciona tu idioma',
    },
    MENU: {
      NEW: 'Nuevo',
      ACTIONS: 'Acciones',
      CREATE_POST: 'Crear nueva publicación',
      PAGES: 'Páginas',
      FEATURES: 'Características',
      APPS: 'Aplicaciones',
      DASHBOARD: 'Panel de control',
      CUSTOMER_INSIGHTS: 'Información del cliente',
      PROFILE: 'Perfil',
      USER_MANAGEMANET: 'Gestión de usuarios',
      USER_ROLE_MANAGEMANET: 'Gestión de roles de usuario',
      ROLE_PERMISSION_GROUP: 'Grupo de permisos de rol',
      MY_SUBSCRIPTIONS: 'Mis Suscripciones',
      COUPON_MANAGEMANET: 'Gestión de cupones',
      SELECT_STORE: 'Seleccionar sucursal',
    },
    HEADER_MENU: {
      THEME: {
        LIGHT: 'Claro',
        DARK: 'Oscuro',
        SYSTEM: 'Sistema',
      },
      PROFILE_MENU: {
        LANGUAGE: 'Idioma',
        SWITCH_TO_USER: 'Cambiar a usuario',
        SIGNOUT: 'Cerrar sesión',
        CONFIRM_LOGOUT: '¿Estás seguro de que deseas cerrar sesión?',
      }
    },
    SIGNIN_MODULE: {
      SIGNIN: 'Iniciar sesión',
      EMAIL: 'Correo electrónico',
      EMAIL_REQUIRED: 'El correo electrónico es obligatorio',
      EMAIL_INVALID: 'El correo electrónico no es válido',
      EMAIL_ATLEAST3_SYMBOLS: 'El correo electrónico debe tener al menos 3 caracteres',
      EMAIL_MAX_VALIDATION: 'El correo electrónico no debe exceder los 360 caracteres',
      PHONE: 'Teléfono',
      PASSWORD: 'Contraseña',
      PASSWORD_REQUIRED: 'La contraseña es obligatoria',
      FORGOT_PASSWORD_LINK: '¿Olvidaste tu contraseña?',
    },
    FORGOT_PASSWORD_MODULE: {
      FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      EMAIL: 'Correo electrónico',
      PHONE: 'Teléfono',
      EMAIL_REQUIRED: 'El correo electrónico es obligatorio',
      EMAIL_INVALID: 'El correo electrónico no es válido',
      EMAIL_ATLEAST3_SYMBOLS: 'El correo electrónico debe tener al menos 3 caracteres',
      EMAIL_MAX_VALIDATION: 'El correo electrónico no debe exceder los 360 caracteres',
      FORGOT_ERROR: 'Lo siento, parece que hay algunos errores detectados, por favor intenta de nuevo.',
      PASSWORD_RESET_LINK_SENT: 'Se ha enviado un enlace para restablecer la contraseña a tu correo electrónico. Por favor, revisa tu bandeja de entrada.',
      SUBMIT: 'Enviar',
    },
    RESET_PASSWORD_MODULE: {
      RESET_PASSWORD: 'Restablecer la contraseña',
      NEW_PASSWORD: 'Nueva contraseña',
      NEW_PASSWORD_REQUIRED: 'La nueva contraseña es obligatoria',
      PASSWORD_MUST_6CHAR_LONG: 'La contraseña debe tener al menos 6 caracteres',
      PASSWORD_COMPLEXITY_REQUIREMENTS: 'La contraseña debe tener al menos una letra minúscula, una letra mayúscula, un dígito y un carácter especial',
      CONFIRM_PASSWORD: 'Confirmar contraseña',
      CONFIRM_PASSWORD_REQUIRED: 'La confirmación de la contraseña es obligatoria',
      PASSWORD_NOT_MATCH: 'Las contraseñas no coinciden',
    },
    PLEASE_WAIT: 'Por favor, espera...',
    SAVE_CHANGES: 'Guardar cambios',
    COUNTINUE: 'Continuar',
    BACK: 'Atrás',
    SUBMIT: 'Enviar',
    CANCEL: 'Cancelar',
    EDIT: 'Editar',
    VIEW: 'Ver',
    DELETE: 'Eliminar',
    PAGES: {
      ROW_PER_PAGE: 'Filas por página',
      TOTAL_RECORD: 'Registros totales',
      NEXT: 'Siguiente',
      PREVIOUS: 'Anterior',
    },
    NO_RECORDS: 'No hay registros disponibles',
    YES: 'Sí',
    NO: 'No',
    DASHBOARD: {
      SELECT_MONTH: 'Seleccionar mes',
      POS_USERS_COUNT: 'Cantidad de usuarios POS',
      TOTAL_NET_PROFIT: 'Beneficio neto total',
      TOTAL_TRANSACTIONS: 'Total de transacciones',
      GROSS_SALES: 'Ventas brutas',
      NET_PROFIT: 'Beneficio neto',
      TRANSACTIONS: 'Transacciones',
      AVERAGE_NET_SALES: 'Ventas netas promedio',
      CURRENT_VS_PREVIOUS_WEEKS: 'Esta semana vs semanas anteriores',
      PREVIOUS_WEEK: 'Semana anterior',
      CURRENT_WEEK: 'Semana actual',
      WEEK: 'Semana',
      USER_ORDERS: 'Pedidos de usuarios',
      USER_ORDERS_SUBTITLE: 'Ver todas las transacciones de usuarios',
      SEARCH_USERS: 'Buscar usuarios...',
      USER_ORDERS_TABLE: {
        NAME: 'Nombre',
        TOTAL_ORDERS: 'Total de pedidos',
        TOTAL_AMOUNT: 'Monto total',
      },
    },
    PRODUCT_PERFORMANCE: {
      TITLE: 'Rendimiento de Productos',
      SUBTITLE: 'Ver métricas de rendimiento de productos',
      FROM_DATE: 'Desde:',
      TO_DATE: 'Hasta:',
      FROM_DATE_PLACEHOLDER: 'Fecha Desde',
      TO_DATE_PLACEHOLDER: 'Fecha Hasta',
      SORT_BY: 'Ordenar Por',
      SEARCH_PRODUCT: 'Buscar Producto',
      TABLE: {
        PRODUCT_NAME: 'Nombre del Producto',
        BARCODE: 'Código de Barras',
        SKU: 'SKU',
        NO_OF_ORDERS: 'Número de Pedidos',
      },
      SORT_OPTIONS: {
        SORT_BY: 'Ordenar Por',
        MOST_BOUGHT: 'Más Comprados',
        LEAST_BOUGHT: 'Menos Comprados',
      },
    },
    SALES_BY_HOURS: {
      TITLE: 'Ventas por Horas',
      SUBTITLE: 'Número de pedidos por hora del día',
      DATE: 'Fecha',
      DATE_PLACEHOLDER: 'Seleccionar Fecha',
      SERIES_NAME: 'Número de Pedidos',
      Y_AXIS_TITLE: 'Número de Pedidos',
      TOOLTIP_SUFFIX: 'pedidos',
    },
    SALES_VS_STORES: {
      TITLE: 'Ventas vs Tiendas',
      SUBTITLE: 'Número de pedidos por tienda',
      FROM_DATE: 'Desde:',
      TO_DATE: 'Hasta:',
      FROM_DATE_PLACEHOLDER: 'Fecha Desde',
      TO_DATE_PLACEHOLDER: 'Fecha Hasta',
      SERIES_NAME: 'Número de Pedidos',
      Y_AXIS_TITLE: 'Número de Pedidos',
      TOOLTIP_SUFFIX: 'pedidos',
    },
    SALES_VS_CATEGORIES: {
      TITLE: 'Ventas vs Categorías',
      SUBTITLE: 'Número de pedidos por categoría',
      FROM_DATE: 'Desde:',
      TO_DATE: 'Hasta:',
      FROM_DATE_PLACEHOLDER: 'Fecha Desde',
      TO_DATE_PLACEHOLDER: 'Fecha Hasta',
      SERIES_NAME: 'Número de Pedidos',
      Y_AXIS_TITLE: 'Número de Pedidos',
      TOOLTIP_SUFFIX: 'pedidos',
    },
    SALES_VS_GROUPS: {
      TITLE: 'Ventas vs Grupos',
      SUBTITLE: 'Número de pedidos por grupo',
      FROM_DATE: 'Desde:',
      TO_DATE: 'Hasta:',
      FROM_DATE_PLACEHOLDER: 'Fecha Desde',
      TO_DATE_PLACEHOLDER: 'Fecha Hasta',
      SERIES_NAME: 'Número de Pedidos',
      Y_AXIS_TITLE: 'Número de Pedidos',
      TOOLTIP_SUFFIX: 'pedidos',
    },
    SALES_VS_DAYS: {
      TITLE: 'Ventas vs Días',
      SUBTITLE: 'Número de pedidos por día de la semana',
      WEEK: 'Semana:',
      WEEK_PLACEHOLDER: 'Seleccionar Semana',
      SERIES_NAME: 'Número de Pedidos',
      Y_AXIS_TITLE: 'Número de Pedidos',
      TOOLTIP_SUFFIX: 'pedidos',
    },

    VENDOR_PROFILE: {
      PROFILE: 'Perfil',
      CHANGE_PASSWORD: 'Cambiar contraseña',
    },
    PROFILE_DETAILS_TAB: {
      PROFILE_DETAILS: 'Detalles del perfil',
      NAME: 'Nombre',
      EMAIL_OR_PHONE: 'Correo electrónico',
    },
    CHANGE_PASSWORD_TAB: {
      OLD_PASSWORD: 'Contraseña anterior',
      OLD_PASSWORD_REQUIRED: 'La contraseña anterior es obligatoria',
      NEW_PASSWORD: 'Nueva contraseña',
      NEW_PASSWORD_REQUIRED: 'La nueva contraseña es obligatoria',
      PASSWORD_MUST_6CHAR_LONG: 'La contraseña debe tener al menos 6 caracteres',
      PASSWORD_COMPLEXITY_REQUIREMENTS: 'La contraseña debe tener al menos una letra minúscula, una letra mayúscula, un dígito y un carácter especial',
      CONFIRM_PASSWORD: 'Confirmar contraseña',
      CONFIRM_PASSWORD_REQUIRED: 'Confirmar contraseña es obligatorio',
      PASSWORD_NOT_MATCH: 'Las contraseñas no coinciden',
    },
    USER_MANAGEMENT: {
      SEARCH_USERS: 'Buscar usuarios',
      USERS: 'Usuarios',
      NEW_USER: 'Nuevo usuario',

      CONFIRM_DELETE_MSG: '¿Estás seguro de que deseas eliminar a este usuario?',
      USER_TABLE: {
        NAME: "Nombre",
        EMAIL: "Correo electrónico",
        ROLES: "Roles",
        STORES: "Tiendas",
        ACTIONS: "Acciones"
      },
      VIEW_USERS: {
        USER_DETAIL: 'Detalles del usuario',
        NAME: 'Nombre',
        EMAIL: 'Correo electrónico',
        ROLE_NAME: 'Nombre del rol',
        MODULE_WISE_ROLE_PERMISSION: 'Permisos de rol por módulo',
        ADD: 'Añadir',
        EDIT: 'Editar',
        VIEW: 'Ver',
        DELETE: 'Eliminar',
      },
      ADD_USER: 'Añadir usuario',
      EDIT_USER: 'Editar usuario',
      DELETE_USER: 'Eliminar usuario',
      ADD_EDIT: {
        NAME: 'Nombre',
        EMAIL: 'Correo electrónico',
        ROLE: 'Rol',
        STORE: 'Sucursal',
        SELECT_ROLE: 'Seleccionar rol',
        SELECT_STORE: 'Seleccionar sucursal',
        PIN: 'PIN',
        PIN_INVALID: 'El PIN debe tener entre 4 y 6 dígitos.',
      }
    },
    USER_ROLE_MANAGEMENT: {
      USER_ROLES: 'Roles de usuario',
      ADD_USER_ROLE: 'Añadir rol de usuario',
      CONFIRM_DELETE_MSG: '¿Estás seguro de que deseas eliminar este rol de usuario?',
      ROLE_TABLE: {
        NAME_IN_ENGLISH: 'Nombre en Inglés',
        NAME_IN_SPANISH: 'Nombre en Español',
        DESCRIPTION: 'Descripción',
        BACKOFFICE_ACCESS: 'Acceso a Back Office',
        ACTIONS: 'Acciones',
      },
      DELETE_USER_ROLE: 'Eliminar rol de usuario',
      ADD_ROLE: 'Añadir rol',
      EDIT_ROLE: 'Editar rol',
      ADD_EDIT: {
        NAME: 'Nombre',
        NAME_IN_ENGLISH: 'Nombre en Inglés',
        NAME_IN_SPANISH: 'Nombre en Español',
        DESCRIPTION: 'Descripción',
        CAN_ACCESS_BACKOFFICE: 'Puede acceder a Back Office',
        SELECT_ALL_PERMISSION: 'Seleccionar todos los permisos',
        MODULE_WISE_ROLE_PERMISSION: 'Permisos de rol por módulo',
        ADD: 'Añadir',
        EDIT: 'Editar',
        VIEW: 'Ver',
        DELETE: 'Eliminar',
      }
    },
    DEVICE_MANAGEMENT: {
      DEVICES: 'Dispositivos',
      SEARCH_DEVICES: 'Buscar dispositivos',
      CONFIRM_DELETE_MSG: '¿Estás seguro de que deseas eliminar este dispositivo?',
      DEVICE_TABLE: {
        NAME: 'Nombre',
        STATUS: 'Estado',
        BATTERY: 'Batería',
        LOCATION: 'Ubicación',
        LAST_UPDATE: 'Última actualización',
        ACTIONS: 'Acciones',
      },
      ADD_EDIT: {
        NAME: 'Nombre',
        BATTERY: 'Batería',
        STATUS: 'Estado',
        LOCATION: 'Ubicación',
        SELECT_LOCATION: 'Seleccionar ubicación',
      },
      SELECT_STATUS: 'Seleccionar estado',
      ACTIVE: 'Activo',
      INACTIVE: 'Inactivo',
      SORT_BY: 'Ordenar por',
      ASC: 'Ascendente',
      DESC: 'Descendente',
      DELETE_DEVICE: 'Eliminar dispositivo',
      ADD_DEVICE: 'Añadir dispositivo',
      EDIT_DEVICE: 'Editar dispositivo',
    },
    COUPON_MANAGEMENT: {
      COUPONS: 'Cupones',
      CONFIRM_DELETE_MSG: '¿Estás seguro de que deseas eliminar este cupón?',
      COUPON_TABLE: {
        TITLE: 'Título',
        CODE: 'Código',
        AMOUNT_PERCENT: 'Monto o porcentaje',
        COUPON_TYPE: 'Tipo de cupón',
        NUMBER_OF_USED: 'Número de usos',
        STATUS: 'Estado',
        ACTIONS: 'Acciones',
      },
      ADD_EDIT: {
        TITLE: 'Título',
        CODE: 'Código',
        AMOUNT_PERCENT: 'Monto o porcentaje',
        START_DATE: 'Fecha de inicio',
        END_DATE: 'Fecha de finalización',
        NUMBER_OF_USE: 'Número de usos',
        TYPE_OF_AMOUNT: 'Tipo de monto',
        AMOUNT: 'Monto',
        PLEASE_SELECT_BRANCH_LOCATION: 'Por favor, selecciona la ubicación de la sucursal',
      },
      SELECT_TYPE: 'Seleccionar tipo',
      FIXED_AMOUNT: 'Monto fijo',
      PERCENTAGE_AMOUNT: 'Monto en porcentaje',
      SELECT_COUPON_TYPE: 'Seleccionar tipo de cupón',
      COUPON: 'Cupón',
      GIFT_CARD: 'Tarjeta de regalo',
      FILTER_BY: 'Filtrar por',
      ALL: 'Todos',
      UTILIZED: 'Utilizados',
      SELECT_STATUS: 'Seleccionar estado',
      ENABLE: 'Habilitar',
      DISABLE: 'Deshabilitar',
      ADD_COUPON: 'Añadir cupón',
      EDIT_COUPON: 'Editar cupón',
      DELETE_COUPON: 'Eliminar cupón',
    },
    ROLE_PERMISSION_GROUP: {
      ROLE_PERMISSION_GROUPS: 'Grupo de permisos de rol',
      SELECT_PERMISSION_GROUP: 'Seleccionar grupo de permisos',
      EDIT_GROUP_ROLE: 'Editar rol de grupo',
      ADD_GROUP_ROLE: 'Agregar rol de grupo',
      CONFIRM_DELETE_MSG: '¿Está seguro de que desea eliminar este grupo de permisos de rol?',
      ROLE_TABLE: {
        NAME_IN_ENGLISH: 'Nombre en inglés',
        NAME_IN_SPANISH: 'Nombre en español',
        DESCRIPTION: 'Descripción',
        ACTIONS: 'Acciones',
      },
      ADD_EDIT: {
        NAME_IN_ENGLISH: 'Nombre en inglés',
        NAME_IN_SPANISH: 'Nombre en español',
        DESCRIPTION: 'Descripción',
        SELECT_ALL_PERMISSION: 'Seleccionar todos los permisos',
        MODULE_WISE_ROLE_PERMISSION: 'Permisos por módulo del rol',
        ADD: 'Agregar',
        EDIT: 'Editar',
        VIEW: 'Ver',
        DELETE: 'Eliminar',
      }
    },
    MY_SUBSCRIPTIONS: {
      MY_SUBSCRIPTIONS: 'Mis Suscripciones',
      CURRENT_PLAN: 'Plan Actual',
      MY_SUBSCRIPTION_TABLE: {
        PLAN_NAME: 'Nombre del plan',
        PRICE: 'Precio',
        DATE: 'Fecha',
        TRANSACTION_ID: 'ID de transacción',
        AMOUNT: 'Monto',
        PURCHASE_TYPE: 'Tipo de compra',
        STATUS: 'Estado',
        ACTION: 'Acción',
        INVOICE: 'Factura',
      },
      DETAIL: {
        NAME: 'Nombre',
        EMAIL: 'Correo electrónico',
        STATUS: 'Estado',
        PLAN_NAME: 'Nombre del plan',
        START_DATE: 'Fecha de inicio',
        END_DATE: 'Fecha de fin',
        AMOUNT: 'Monto',
        BILLING_CYCLE: 'Ciclo de facturación',
      },
    },
    STATUS: {
      ACTIVE: 'Activo',
      INACTIVE: 'Inactivo',
    },
    PAYMENT_CYCLE: {
      MONTHLY: 'Mensual',
      YEARLY: 'Anual',
    },
    PERMISSON_MENU: {
      home: "Inicio",
      generate_order: "Generar pedido",
      order_status: "Estado del pedido",
      order_history: "Historial de pedidos",
      online_ordering: "Pedidos en línea",
      manage_category: "Gestionar categoría",
      manage_groups: "Gestionar grupos",
      manage_items: "Gestionar artículos",
      manage_modifiers: "Gestionar modificadores",
      vendor_list: "Lista de proveedores",
      vendor_purchase_orders: "Órdenes de compra de proveedores",
      vendor_payments: "Pagos a proveedores",
      shift_management: "Gestión de turnos",
      my_shift: "Mi turno",
      inventory_management: "Gestión de inventario",
      pos_management: "Gestión de POS",
      manage_seating_areas: "Gestionar áreas de asientos",
      manage_reservation: "Gestionar reservas",
      table_management: "Gestión de mesas",
      waiting_list_management: "Gestión de lista de espera",
      billing: "Facturación",
      store_management: "Gestión de tiendas",
      kds_management: "Gestión del sistema de cocina (KDS)",
      kitchen_display_system: "Sistema de cocina (KDS)",
      display_settings: "Configuración de pantalla",
      general_settings: "Configuración general",
      tax_management: "Gestión de impuestos",
      profile_setting: "Configuración de perfil",
      order_receipt_setting: "Configuración del recibo de pedido",
      image_library: "Biblioteca de imágenes",
      manage_notification_preference: "Gestionar preferencias de notificación",
      transactions: "Transacciones",
      walkthrough: "Guía interactiva"
    }
  },
};
